// extracted by mini-css-extract-plugin
export default {"slideShow":"SlideShow_slideShow__rO3PI"};